module.exports = __webpack_public_path__ + "img/avatar_wrestler.5d5e845f.svg";